'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

function CustomConstructor(_ref) {
  var builder = _ref.builder,
      title = _ref.title;

  var elements = {
    title: {
      content: title + ' | ' + (0, _lodash.get)(builder, 'name'),
      attrs: {}
    }
  };

  return elements;
}

exports.default = CustomConstructor;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-pagehelmet/build/Custom.js
// module id = 1145
// module chunks = 0